const initialState = {};

const hexesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_HEX_TOKEN':
      return {
        ...state,
        [action.payload.key]: action.payload.tokenType
      };
    case 'CLEAR_HEX': {
      const newHexes = { ...state };
      delete newHexes[action.payload];
      return newHexes;
    }
    case 'CLEAR_ALL_HEXES':
      return {};
    case 'LOAD_STATE':
      return action.payload.loadedState.hexes || {};
    default:
      return state;
  }
};

export default hexesReducer;
